{
  "back": "Back",
  "badge": "Official verification",
  "title": "Certificate validation",
  "subtitle": "Enter the certificate code (hash) to confirm its authenticity and view the document.",
  "search": {
    "placeholder": "Paste the certificate code",
    "submit": "Validate"
  },
  "revoked": {
    "title": "Certificate revoked",
    "subtitle": "This certificate has been revoked and is no longer valid."
  },
  "notFound": {
    "title": "Certificate not found",
    "subtitle": "Check the code and try again.",
    "requestFailed": "Unable to validate the code"
  },
  "footer": "Xtreed · Learning platform",
  "valid": {
    "title": "Authentic certificate",
    "subtitle": "Officially issued by the platform.",
    "student": "Student",
    "content": "Content",
    "issuedAt": "Issued on",
    "code": "Code"
  },
  "preview": {
    "fileName": "certificate-{{code}}.png",
    "iframeTitle": "Certificate preview",
    "view": "View certificate",
    "download": "Download"
  }
}
